import { render, staticRenderFns } from "./Customerlist.vue?vue&type=template&id=6634c098"
import script from "./Customerlist.vue?vue&type=script&lang=js"
export * from "./Customerlist.vue?vue&type=script&lang=js"
import style0 from "./Customerlist.vue?vue&type=style&index=0&id=6634c098&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports